



<app-navbar></app-navbar>

<router-outlet></router-outlet>

